<template>
  <b-tab @click="getRoutes">
    <!--<template #title :title-link-class="linkClass(0)" > -->
    <template #title >
      <font-awesome-icon class="fa-regultar" icon="house-user" /> Actividad
    </template>
    <slot name="button-search"> </slot>
    <section>
      <b-container fluid>
        <b-row>
          <b-col cols="12" lg="3" class="my-1">
            <label class="text-dark font-weight-bold">Fecha Ruta</label>
            <b-form-input type="date" v-model="actualDate"></b-form-input>
          </b-col>
          <b-col cols="12" lg="3" class="my-1" v-show="!isProfileProvider">
            <label class="text-dark font-weight-bold">Proveedor</label>
            <b-form-group>
                <b-form-select
                  v-model="selectedOptionProvider"
                  size="md"
                  :options="optionsProvider"
                >
                  <template #first>
                    <b-form-select-option :value="null">
                      Todos
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
           
          </b-col>
          <b-col md="3">
            <label class="text-dark font-weight-bold">Tienda</label>
            <b-form-group>
                <b-form-select
                  v-model="selectedStore"
                  size="md"
                  :options="optionStores"
                >
                  <template #first>
                    <b-form-select-option :value="null">
                      Todos
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
          </b-col>
          <b-col cols="12" lg="3" class="my-1">
            <label class="hidden margin-0">Hidden</label>
            <b-button @click="getRoutes" class="btn-dark width-100">
              <font-awesome-icon icon="search" /> Buscar
            </b-button>
          </b-col>
          <b-col md="3" v-show="routes.length" >
            <label class="hidden margin-0">Hidden</label>
            <b-form-group>
              <b-form-select
                @change="getRoutesFilterByQuantity"
                v-model="selectedQuantity"
                size="md"
                :options="optionsQuantity"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="6" lg="6">
            <p>Usuarios en ruta</p>
          </b-col>
          <b-col cols="12" lg="6" class="my-1 float-right">
            <b-row class="float-right">
              <b-col cols="auto">
                <b-button class="btn-blue" @click="$bvModal.show('modal-1')">
                  <font-awesome-icon class="fa-regultar" icon="download" />
                  Exportar a excel
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="bg-white">
      <b-container fluid>
        <b-col lg="12">
          <b-row>
            <b-col cols="2" md="2" lg="2">
              <!-- <h3>{{ complianceTotal }} %</h3> -->
              <h3>{{ totalCompliance }}%</h3>
              <span class="text-large-gray">Cumplimiento total</span>
            </b-col>
            <b-col cols="2" md="2" lg="2">
              <!-- <h3>{{ complianceTotal }} %</h3> -->
              <h3>{{ totalAsigned }}</h3>
              <span class="text-large-gray">Asignadas</span>
            </b-col>
            <b-col cols="2" md="2" lg="2">
              <!-- <h3>{{ complianceTotal }} %</h3> -->
              <h3>{{ totalManaged }}</h3>
              <span class="text-large-gray">Gestionadas</span>
            </b-col>
            <b-col cols="2" md="2" lg="2">
              <!-- <h3>{{ complianceTotal }} %</h3> -->
              <h3>{{ totalRealized }} %</h3>
              <span class="text-large-gray">Realizadas</span>
            </b-col>
            <b-col cols="2" md="2" lg="2">
              <!-- <h3>{{ complianceTotal }} %</h3> -->
              <h3>{{ totalPartial }} %</h3>
              <span class="text-large-gray">Parciales</span>
            </b-col>
            <b-col lg="2">
              <!-- <h3>{{ complianceTotal }} %</h3> -->
              <h3>{{ totalUnrealized }}%</h3>
              <span class="text-large-gray">No realizadas</span>
            </b-col>
          </b-row>
        </b-col>
      </b-container>
    </section>
    <section>
      <b-container fluid>
        <b-row>
          <b-col md="12" lg="12">
            <p>Proveedores</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            lg="12"
            v-for="(route, index) in routes"
            :key="index"
            class="margin-bottom-5 border-all-gray padding-none-lr"
          >
            <b-row class="bg-sky margin-none-lr padding-two-tb">
              <b-col md="6" lg="6">
                <b-row>
                  <b-col cols="auto">
                    <font-awesome-icon class="fa-regular" icon="user" />
                    <span class="text-md" v-show="route.services.length">
                      {{ route.services[0].name_technical }}
                    </span>
                  </b-col>
                  <b-col cols="auto">
                    <span class="text-md">
                      {{ route.truck_identifier }}
                    </span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <p>{{ route.provider }}</p>
                  </b-col>
                </b-row>
              </b-col>

              <b-col md="6" lg="6">
                <b-row>
                  <b-col lg="3">
                    <div style="position: relative; padding-bottom: 7px">
                      <p class="txt-lg">
                        {{ assignedRoute(route) }}
                      </p>
                    </div>

                    <div style="position: absolute; bottom: 0">
                      <span class="text-large-gray">Asignados</span>
                    </div>
                  </b-col>
                  <b-col lg="3">
                    <div style="position: relative; padding-bottom: 7px">
                      <p class="txt-lg">
                        {{ managedRoutes(route) }}
                      </p>
                    </div>

                    <div style="position: absolute; bottom: 0">
                      <span class="text-large-gray">Gestionados</span>
                    </div>
                  </b-col>
                  <b-col lg="3">
                    <div style="position: relative; padding-bottom: 7px">
                      <vue-ellipse-progress
                        color="#19BE2B"
                        thickness="3"
                        :progress="compliancePercentageRoutes(route)"
                        :size="39"
                        fontSize="11px"
                      >
                        <template v-slot:legend-value>
                          <span slot="legend-value">%</span>
                        </template>
                      </vue-ellipse-progress>
                    </div>

                    <div style="position: absolute; bottom: 0">
                      <span class="text-large-gray">Cumplimientos</span>
                    </div>
                  </b-col>
                  <b-col lg="3">
                    <b-button class="btn-dark" v-b-toggle="`collapse-${index}`">
                      <font-awesome-icon
                        class="fa-regultar color-white"
                        icon="chevron-down"
                      />
                      Ver detalle
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <!-- <div class="bg-white"> -->
            <b-collapse
              :id="`collapse-${index}`"
              class="padding-two-lr bg-color-white"
            >
              <b-row>
                <b-col md="3" lg="3">
                  <b-row>
                    <b-col cols="6">
                      <span>{{ realizedRoutes(route) }} Realizados</span>
                    </b-col>
                    <b-col cols="6" class="float-right">
                      <span>{{ complianceTotal(route) }}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <b-progress
                        :value="complianceTotal(route)"
                        :max="max"
                        variant="success"
                      ></b-progress>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="6">
                      <span>{{ NoRealizedRoutes(route) }} No realizados</span>
                    </b-col>
                    <b-col cols="6" class="float-right">
                      <span>{{ complianceTotalNoRealized(route) }}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <b-progress
                        :value="complianceTotalNoRealized(route)"
                        :max="max"
                        variant="danger"
                      ></b-progress>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="9">
                  <timeline :routes="route"></timeline>
                </b-col>
              </b-row>
              <b-row>
                <!-- <b-col cols="12" md="4" lg="4" class="padding-three-top">
                      <b-row> -->
                <b-col
                  cols="12"
                  v-for="(item, idx) in route.services"
                  :key="idx"
                  class="padding-three-top"
                >
                  <b-row>
                    <b-col cols="12" md="4" lg="4">
                      <b-row>
                        <b-col md="6" lg="6" xs="12">
                          <b-row>
                            <b-col  md="6">
                              <span class="color-orange" style="font-size: 12px">
                            Fecha de llegada
                          </span>
                            </b-col>
                            <b-col md="6">
                              <span>{{item.initDispatche}}</span>
                            </b-col>
                          </b-row>
                          
                          <p class="font-weight-bold" style="font-size: 11px">
                            {{ item.identifier }}
                          </p>
                          <span>
                            {{ item.client_full_name }}
                          </span> <br/>
                          <span class="color-orange" style="font-size: 13px">Tienda: {{item.store}}</span>
                          <b-row>
                            <b-col md="12">
                               <span class="color-orange" style="font-size: 13px">Sku servicio: {{item.desc_service}}</span>
                            </b-col>
                          </b-row>
                         
                        </b-col>
                        <b-col md="4" lg="4">
                          <b-button
                            v-bind:class="[
                              item.descState == 'REALIZADA'
                                ? activeClass
                                : item.descState == 'EN_RUTA'
                                ? inRouteClass
                                : item.descState == 'NO_REALIZADA'
                                ? inactiveClass
                                : 'unknown',
                              errorClass,
                            ]"
                          >
                            {{ item.descState }}
                          </b-button>
                        </b-col>
                        <b-col md="1">
                          <b-button
                            @click="setIdRoute(item, index)"
                            v-b-toggle="
                              `collapse-${route.provider}-${item.truck_identifier}-${idx}`
                            "
                            class="bg-color-white border-radius-50 color-gray"
                          >
                            <font-awesome-icon
                              class="fa-regultar color-gray"
                              icon="chevron-right"
                            />
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col cols="12" md="8" lg="8" class="bg-sky">
                      <div v-show="item.visible">
                        <b-row class="padding-two-top">
                          <b-col cols="12" md="6" lg="6">
                            <p class="font-weight-500 font-size-20">
                              Datos del cliente
                            </p>
                            <ul class="list-style-none">
                              <li>
                                Dni:
                                <span class="font-weight-500">
                                  {{ item.identityDocument }}
                                </span>
                              </li>
                              <li>
                                Nombre:
                                <span class="font-weight-500">
                                  {{ item.client_full_name }}</span
                                >
                              </li>
                             <!-- <li>
                                Dirección:
                                <span class="font-weight-500"
                                  >{{ item.contact_address }}
                                </span>
                              </li>-->
                              <li>
                                Observaciones:
                                <span class="font-weight-500">
                                  {{ item.service_observation }}</span
                                >
                              </li>
                            </ul>
                          </b-col>
                          <b-col cols="12" md="6" lg="6">
                            <b-row>
                              <b-col md="12">
                                <b-button
                                  @click="$bvModal.show('modal-photos')"
                                  class="
                                    bg-color-white
                                    btn-white-v
                                    border-black-all
                                    color-gray
                                  "
                                >
                                  Adjuntar Foto
                                </b-button>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col
                                md="12"
                                v-if="item.idRoute == idRoute && photos.length"
                              >
                                <p class="margin-bottom-none">
                                  Fotos {{ photos.length }}
                                </p>
                                <b-row>
                                  <b-col
                                    md="3"
                                    v-for="(photo, index) in photos"
                                    :key="index"
                                  >
                                    <b-img
                                      @click="$bvModal.show('modal-carousel')"
                                      v-bind="mainProps"
                                      :src="photo.photoUrl"
                                      fluid
                                      alt="Fluid image"
                                    ></b-img>
                                  </b-col>
                                </b-row>
                              </b-col>
                              <b-col
                                md="12"
                                v-if="
                                  item.idRoute == idRoute && signatures.length
                                "
                              >
                                <p class="margin-bottom-none">
                                  Firmas {{ signatures.length }}
                                </p>
                                <b-row>
                                  <b-col
                                    md="3"
                                    v-for="(signature, index) in signatures"
                                    :key="index"
                                  >
                                    <b-img
                                      @click="$bvModal.show('modal-signatures')"
                                      v-bind="mainProps"
                                      :src="signature.photoUrl"
                                      fluid
                                      alt="Fluid image"
                                    ></b-img>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col> 
                  </b-row>
                </b-col>
              </b-row>
            </b-collapse>
          </b-col>
        </b-row>
        <b-row v-show="routes.length > 0">
          <b-col md="12" class="text-center">
            <b-button @click="getMoreRoutes"> Ver más rutas </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <b-modal
      centered
      size="lg"
      hide-footer
      id="modal-signatures"
      title="Ver fotos"
      title-class="left-auto"
    >
      <carousel :photos="signatures" />
    </b-modal>
    <b-modal
      centered
      size="lg"
      hide-footer
      id="modal-carousel"
      title="Ver fotos"
      title-class="left-auto"
    >
      <carousel :photos="photos" />
    </b-modal>
    <b-modal
      hide-footer
      id="modal-photos"
      title="Adjuntar fotos"
      title-class="left-auto"
      header-class="bg-light"
    >
      <photos :idRoute.sync="idRoute" />
    </b-modal>
  </b-tab>
</template>

<script>
import {getStores} from '../../assets/js/common'
import Carousel from "../../components/OneTrack/Carousel.vue";
import { mapState } from "vuex";
import Timeline from "./Timeline.vue";
import moment from "moment";
import axios from "axios";
import Photos from "../../components/OneTrack/Photos.vue";
export default {
  name: "Activity",
  components: { Timeline, Carousel, Photos },
  data() {
    return {
      activeClass: "active-realized",
      inRouteClass: "active-inroute",
      inactiveClass: "unrealized",
      errorClass: "text-danger",
      max: 100,
      msg: "",
      selectedQuantity:100,
      optionsQuantity: [
        { text: "Mostrar 100 rutas", value: "100" },
        { text: "Mostrar 150 rutas", value: "150" },
        { text: "Mostrar 300 rutas", value: "300" },
        { text: "Mostrar 400 rutas", value: "400" },
        { text: "Mostrar 500 rutas", value: "500" },
        { text: "Mostrar 600 rutas", value: "600" },
      ],
      emailUser: "",
      numberOs: "",
      documentNumber: "",
      identityDoc: "",
      startDate: moment().format("YYYY-MM-DD"),
      endDateOrder: moment().format("YYYY-MM-DD"),
      dateEstimatedBegin: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      actualDate: moment().format("YYYY-MM-DD"),
      optionStores:[],
      selectedStore:null,
      optionsProvider: [],
      signatures: [],
      photos: [],
      selectedOptionProvider: null,
      optionStates: [],
      selectedState: { idTypeMotive: null, idState: null },
      dataRoutes: "",
      isBusy: false,
      idRoute: 0,
      idService: 0,
      routes: [],
      previewData: { idx: null, idRoute: null },
      mainProps: {
        width: 40,
        height: 40,
      },
      limit: 100,
      counter: 1,
    };
  },
  props: {
    tabIndex: {
      type: Number,
    },
  },
  computed: {
    isProfileProvider() {
      let up = this.perfil.toUpperCase();
      if (up === "PROVEEDOR") return true;
      return false;
    },
    ...mapState("module", ["username", "perfil", "idProvider"]),
    totalUnrealized() {
      let routesUnrealized = 0;
      let totalRoutes = 0;

      this.routes.forEach((element) => {
        element.services.forEach((a) => {
          if (a.state == 7) {
            routesUnrealized++;
          }
          totalRoutes++;
        });
      });
      let complaince = (routesUnrealized * 100) / totalRoutes;
      if (this.routes.length && routesUnrealized > 0)
        return complaince.toFixed(2);
      else return 0;
    },
    totalPartial() {
      let routesPartial = 0;
      let totalRoutes = 0;

      this.routes.forEach((element) => {
        element.services.forEach((a) => {
          if (a.state == 11) {
            routesPartial++;
          }
          totalRoutes++;
        });
      });
      let complaince = (routesPartial * 100) / totalRoutes;
      if (this.routes.length && complaince > 0) return complaince.toFixed(2);
      else return 0;
    },
    totalAsigned() {
      let total = 0;
      if (this.routes.length) {
        this.routes.forEach((element) => {
          element.services.forEach(() => {
            total++;
          });
        });
      }

      if (this.routes.length && total > 0) return total;
      else return 0;
    },
    totalRealized() {
      let routesRealized = 0;
      let totalRoutes = 0;
      if (this.routes.length) {
        this.routes.forEach((element) => {
          element.services.forEach((a) => {
            if (a.state == 3) {
              routesRealized++;
            }
            totalRoutes++;
          });
        });
      }
      let complaince = (routesRealized * 100) / totalRoutes;
      if (this.routes.length && routesRealized > 0)
        return complaince.toFixed(2);
      else return 0;
    },
    totalManaged() {
      let routesManaged = 0;

      this.routes.forEach((element) => {
        element.services.forEach((a) => {
          if (a.state == 3 || a.state == 7 || a.state == 13) {
            routesManaged++;
          }
        });
      });

      if (this.routes.length) return routesManaged;
      else return 0;
    },
    totalCompliance() {
      let routesCompliance = 0;
      let totalRoutes = 0;
      if (this.routes.length) {
        this.routes.forEach((element) => {
          element.services.forEach((a) => {
            if (a.state == 3 || a.state == 7 || a.state == 13) {
              routesCompliance++;
            }
            totalRoutes++;
          });
        });
      }
      let complaince = (routesCompliance * 100) / totalRoutes;
      if (this.routes.length && routesCompliance > 0)
        return complaince.toFixed(2);
      else return 0;
    },
  },
  created() {
    this.getProvidersList();
    this.getStoresCombo();
  },
  methods: {
    async getStoresCombo() {
        let data=await getStores();
          this.optionStores = data;
   
    },
    assignedRoute(item) {
      return item.services.length;
    },
    compliancePercentageRoutes(item) {
      let route = item.services.filter(
        (item) => item.state == 3 || item.state == 7
      );
      let doneRoutes = route.length;
      let totalRoutes = item.services.length;
      let complaince = (doneRoutes * 100) / totalRoutes;
      if (doneRoutes <= 0 && totalRoutes != null) return 0;
      else return Number(complaince.toFixed(2));
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["link-active"];
      } else {
        return ["transparent"];
      }
    },
    realizedRoutes(item) {
      let route = item.services.filter((item) => item.state == 3);
      return route.length;
    },
    NoRealizedRoutes(item) {
      let route = item.services.filter((item) => item.state == 7);
      return route.length;
    },
    complianceTotal(item) {
      let route = item.services.filter((item) => item.state == 3);
      let doneRoutes = route.length;
      let totalRoutes = item.services.length;
      let complaince = (doneRoutes * 100) / totalRoutes;
      if (doneRoutes <= 0 && totalRoutes != null) return 0;
      else return complaince;
    },
    complianceTotalNoRealized(item) {
      let route = item.services.filter((item) => item.state == 7);
      let doneRoutes = route.length;
      let totalRoutes = item.services.length;
      let complaince = (doneRoutes * 100) / totalRoutes;
      if (doneRoutes <= 0 && totalRoutes != null) return 0;
      else return complaince;
    },
    clearPreviewsPhotos(){
      if (this.signatures.length) this.signatures = [];
      if (this.photos.length) this.photos = [];
    },
    async setIdRoute(item, firstIdx) {
     this.clearPreviewsPhotos();
      if (this.previewData.idRoute != null && this.previewData.idx != null) {
        let ix = this.routes[this.previewData.idx].services.findIndex(
          (i) => i.idRoute == this.previewData.idRoute
        );
        console.log(this.previewData.idRoute, "ruta previa", ix);
        this.routes[this.previewData.idx].services[ix].visible =
          !this.routes[this.previewData.idx].services[ix].visible;
      }
      this.previewData.idRoute = item.idRoute;
      this.previewData.idx = firstIdx;
      let i = this.routes[firstIdx].services.findIndex(
        (i) => i.idRoute == item.idRoute
      );
      this.routes[firstIdx].services[i].visible =
        !this.routes[firstIdx].services[i].visible;
      this.idRoute = item.idRoute;
      await this.getPhotosRoute(item);
      await this.getSignatureClient(item); 
    },
    managedRoutes(item) {
      let route = item.services.filter(
        (item) => item.state == 3 || item.state == 7
      );
      return route.length;
    },
    async getMoreRoutes() {
      try {
        this.counter += 1;
        let userProvider = "";
        if (this.perfil === "PROVEEDOR") {
          userProvider = "&UserProvider=" + encodeURIComponent(this.username);
        } else if (this.selectedOptionProvider) {
          userProvider = "&UserProvider=" + encodeURIComponent(this.selectedOptionProvider);
        }
        let totalLimit = this.limit * this.counter;
        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_BASE_ONETRACK +
            "/route/getTechnicalRoute?Pagination=true&Date=" +
            this.actualDate +
            userProvider +
            "&page=1&limit=" +
            totalLimit
          // this.startDate
        );
        const list = response.data.map((row) => {
          return {
            services: row.routes,
            provider: row.provider,
            truck_identifier: row.num_doc_technical,
            name_technical: row.name_technical,
          };
        });
        this.routes = list;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    
    async getRoutesFilterByQuantity() {
      try {
        if (this.routes.length) this.resetData();
        let userProvider = "";
        if (this.perfil === "PROVEEDOR") {
          userProvider = "&UserProvider=" + encodeURIComponent(this.username);
        } else if (this.selectedOptionProvider) {
          userProvider = "&UserProvider=" + encodeURIComponent(this.selectedOptionProvider);
        }

        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_BASE_ONETRACK +
            "/route/getTechnicalRoute?Pagination=true&Date=" +
            this.actualDate +
            userProvider +
            "&page=1&limit=" +
            this.selectedQuantity
          // this.startDate
        );
        const list = response.data.map((row) => {
          return {
            services: row.routes,
            provider: row.provider,
            truck_identifier: row.num_doc_technical,
            name_technical: row.name_technical,
          };
        });
        this.routes = list;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    async getRoutes() {
      try {
        if (this.routes.length) this.resetData();
        let userProvider = "";
        let storeCode="";
        if (this.perfil === "PROVEEDOR") {
          userProvider = "&UserProvider=" + encodeURIComponent(this.username);
        } else if (this.selectedOptionProvider) {
          userProvider = "&UserProvider=" + encodeURIComponent(this.selectedOptionProvider);
        }
        if(this.selectedStore){
          storeCode="&Store="+this.selectedStore
        }

        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_BASE_ONETRACK +
            "/route/getTechnicalRoute?Pagination=true&Date=" +
            this.actualDate +
            userProvider +
            storeCode+
            "&page=1&limit=100"
          // this.startDate
        );
        const list = response.data.map((row) => {
          return {
            services: row.routes,
            provider: row.provider,
            truck_identifier: row.num_doc_technical,
            name_technical: row.name_technical,
          };
        });
        this.routes = list;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    resetData() {
      this.routes = [];
      this.previewData={ idx: null, idRoute: null }
    },
    async getPhotosRoute(item) {
      try {
        if (this.photos.length) this.photos = [];
        let response = await axios.get(
          process.env.VUE_APP_BASE_ONETRACK + "/route/photo/" + item.idRoute
        );
        this.photos = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    async getSignatureClient(item) {
      try {
        if (this.signatures.length) this.signatures = [];
        let response = await axios.get(
          process.env.VUE_APP_BASE_ONETRACK + "/route/signature/" + item.idRoute
        );
        const data = response.data.map((row) => {
          return {
            id: row.id,
            idRoute: row.idRoute,
            photoUrl: row.signatureUrl,
            username: row.username,
          };
        });
        this.signatures = data;
      } catch (e) {
        console.log(e);
      }
    },
    async getProvidersList() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_PROVIDER_BASE_BUSINESS +
            "/providers?limit=1000&state=ACTIVE&page=1&pagination=false"
        );
        const data = response.data.map((row) => {
          return {
            value: row.user,
            text: row.user,
          };
        });
        var sortedData= data.sort((a,b) => a.text.localeCompare(b.text))
        this.optionsProvider = sortedData;
      } catch (error) {
        console.log(error);
      } finally {
        //this.$store.commit("SET_LOADING", false)
      }
    },
  },
};
</script>

<style scoped>
.hidden {
  visibility: hidden;
}
.margin-0 {
  margin-bottom: 0;
}
.color-dark {
  color: #405568 !important;
}
.btn-dark {
  background-color: #405568 !important;
  border-color: #405568 !important;
  color: white;
  border-radius: 4px;
}
.float-right {
  float: right !important;
}
.btn-transparent {
  color: transparent;
  background-color: transparent !important;
  color: #405568 !important;
  border-color: #405568;
  border-radius: 4px;
}
.btn-blue {
  background-color: #1b8cf3 !important;
  color: white !important;
  border-color: #1b8cf3 !important;
  border-radius: 4px;
}
.btn-blue:hover {
  color: #1b8cf3 !important;
  background: white !important ;
}
.btn-underline {
  background-color: transparent !important;

  border-radius: 0 !important;
  color: #626262 !important;
  text-decoration: underline;
  border-color: transparent !important
;
}
::v-deep .nav-link:hover {
  border: none !important;
}
::v-deep .b-table thead tr {
  background-color: #f0faff !important;
  border-color: #f0faff !important;
}
::v-deep .b-table thead {
  background-color: red !important;
  color: black !important;
  font-weight: 500 !important;
  border: none !important;
}
.bcg-white {
  background-color: white !important;
}
.padding-lr-none {
  padding-left: 0%;
  padding-right: 0%;
}
.text-dark {
  color: #626262 !important;
  font-size: 14px;
}
.btn-white-v:hover {
  color: white !important;
  background: #626262 !important ;
}
.border-all {
  border: 1px solid #d8d8d8 !important;
}
.border-black-all {
  border: 1px solid #405568 !important;
}
.padding-left-none {
  padding-left: 0 !important;
}
.padding-rigth-none {
  padding-right: 0% !important;
}
.border-sky-all {
  border: 1px solid #71c2fc !important;
  background-color: #eff7ff !important;
}
::v-deep .page-item.active .page-link {
  background: #ff7a00;
  color: white;
  border-color: transparent;
}
::v-deep .page-item.disabled .page-link {
  background: transparent !important;
  border-color: transparent !important;
  color: #ff7a00;
}
::v-deep .page-link {
  color: #676767;
  border-color: transparent;
  font-weight: bold;
  background: transparent;
}
::v-deep .nav-tabs {
  position: absolute !important;
  top: 1% !important;
  z-index: 99 !important;
  left: 30%;
  border-bottom: 0;
}

::v-deep .nav-item {
  border: 1px solid #dee2e6;
}

::v-deep .link-active {
  border-bottom: 3px solid #fb822a !important;
  color: #fb822a !important;
}
.text-large-gray {
  font-size: 16px;
  color: #4e4e4e;
  font-weight: 500;
  line-height: 19px;
}
h3 {
  font-size: 32px !important;
  font-weight: 700 !important;
  line-height: 38px;
  color: #4e4e4e;
}
.bg-white {
  background-color: white !important;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #ebebeb;
  box-shadow: 0px 6px 6px rgba(0, 0, 0, 0.03);
}
.bg-sky {
  background-color: #f4faff !important;
}
.txt-lg {
  font-size: 26px;
  font-weight: 700;
}
.margin-bottom-5 {
  margin-bottom: 2%;
}
.border-all-gray {
  border: 2px solid #dddddd;
  background-color: transparent;
}
.text-md {
  font-size: 18px;
  line-height: 21px;
}
.padding-two-tb {
  padding-top: 2%;
}

.margin-none-lr {
  margin-left: 0;
  margin-right: 0;
}
.padding-two-lr {
  padding-left: 2%;
  padding-right: 2%;
}

.color-orange {
  color: #fb822a;
}

.padding-three-top {
  padding-top: 3%;
}
.border-radius-50 {
  border-radius: 50%;
  border: 1px solid #eeeeee;
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.05);
}
.active-inroute{
  background-color: #ffc107 !important ;
  border: 1px solid #ffc107 !important;
  border-radius: 4px;

  font-size: 13px;
  line-height: 15px;

  color: #212529 !important;
}
.active-realized {
  background-color: #19be2b !important ;
  border: 1px solid #19be2b !important;
  border-radius: 4px;

  font-size: 13px;
  line-height: 15px;

  color: #ffffff !important;
}

.unrealized {
  background-color: #fb465c;
  border: 1px solid #fb465c;
  border-radius: 4px;
  color: white;
  font-size: 13px;
  line-height: 15px;

  color: #ffffff !important;
}
.modal-title {
  text-align: center !important;
}
::v-deep .left-auto {
  margin-left: auto !important;
}
.bg-light {
  background-color: #f7f7f7;
}
::v-deep .nav-link .active {
  border-bottom: 3px solid #fb822a !important;
  color: #fb822a !important;
}
</style>